import { NgTemplateOutlet } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core'
import { TooltipAlignment, TooltipPosition } from './tooltip-position'

/**
 * Important: This is an internal component for the Tooltip directive, not to be used alone
 */
@Component({
  selector: 'ftr-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.css',
  host: {
    '[attr.aria-hidden]': 'true',
    '(mouseover)': 'onMouseOver.emit()',
    '(mouseleave)': 'onMouseLeave.emit()',
  },
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  readonly template = input<TemplateRef<any>>()
  readonly templateContext = input<Object>()
  readonly position = input<TooltipPosition>('above')
  readonly alignment = input<TooltipAlignment>('center')
  readonly indicatorPositionStyle = input<string>()
  readonly message = input<string>()

  readonly onMouseOver = output()
  readonly onMouseLeave = output()

  readonly tooltip = viewChild.required<ElementRef<HTMLElement>>('tooltip')

  protected readonly getClasses = computed<Record<string, boolean>>(() => ({
    tooltip: true,
    [`tooltip--${this.position()}-${this.alignment()}`]: true,
  }))
}
